
import Search from '@/components/Search/Search.vue'

export default {
    components: { Search },
    middleware: 'isSubscribe',
    head () {
        return {
            title: this.$t('search page title')
        }
    }
}
